module.exports = __webpack_public_path__ + "static/img/avatar_r_5.753e1dc6.png";